import React from 'react';
import { Link } from 'react-router-dom';
import chromeIcon from './chrome.svg'; // Adjust path as needed
import toolboxImage from './ege.png';  // Adjust path as needed

const Home = () => {
  return (
    <div className="min-h-screen bg-indigo-50">
      {/* Top notification banner */}
      <div className="bg-indigo-700 text-white py-2 px-4 text-center">
        <p className="flex items-center justify-center">
          <span className="mr-2">⚡</span>
          Supercharge Your ChatGPT - Install Now
        </p>
      </div>

      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Left content section */}
          <div className="w-full md:w-1/2 space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Enhance Your ChatGPT Experience
            </h1>

            <p className="text-lg text-gray-700">
              Take your browser interactions to the next level with advanced
              features like audio downloads, folders, prompt management,
              export options, organized workflows, bulk actions, and many more
              tools designed to improve your productivity and results.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <button className="flex items-center rounded-full border border-gray-300 px-6 py-2.5 font-medium bg-white hover:bg-gray-50 transition-colors">
                <img src={chromeIcon} alt="Chrome" className="mr-2" style={{ width: '20px', height: '20px' }}/>
                Add to Chrome
              </button>

            </div>

            <div className="flex items-center gap-2 pt-2">
              <span className="text-sm text-gray-600"></span>
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            </div>

            <div className="pt-4">
              <h3 className="font-medium text-gray-900">Improve Your Experience Today!</h3>
              <p className="text-sm text-gray-600 mt-1">
                By installing or using ChatGPT Enhancer you agree to the
                <Link to="/terms" className="text-indigo-600 hover:underline mx-1">Terms of Service</Link>
                and
                <Link to="/policy" className="text-indigo-600 hover:underline ml-1">Privacy Policy</Link>
              </p>
            </div>
          </div>

          {/* Right content section with toolbox illustration */}
          <div className="w-full md:w-1/2">
            <div className="bg-white rounded-lg shadow-md p-8">
              <div className="flex justify-center">
                <div className="relative">
                  <img src={toolboxImage} alt="Toolbox" className="mb-4" />
                </div>
              </div>
              <h2 className="text-4xl font-bold text-center">ChatGPT Enhancer</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;